// @ts-nocheck
import React, { Fragment, useState } from "react";
import BreadcrumbsContext from "app/context/BreadcrumbsContext";
import Breadcrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import ButtonDropDown from "app/components/concept/ButtonDropdown/ButtonDropdown";
import Button from "app/components/concept/Button/Button";
import PageContainer from "app/pages/AppDashboard/components/PageContainer/PageContainer";
import StickyBanner, { StickyBannerData } from "app/pages/AppDashboard/components/StickyBanner/StickyBanner";
import PropTypes from "prop-types";

const BreadcrumbsContextComponent = (props) => {
	const [breadcrumbLinks, setBreadcrumbLinks] = useState([]);
	const [breadcrumbTitle, setBreadcrumbTitle] = useState("");
	const [breadcrumbButtons, setBreadcrumbButtons] = useState([]);
	const [actionButton, setActionButton] = useState(null);
	const [breadcrumbDropdownBtn, setBreadcrumbDropdownBtn] = useState([]);
	const [showBreadcrumb, setShowBreadcrumb] = useState(true);
	const [stickyBannerData, setStickyBannerData] = useState<StickyBannerData | null>(null);

	return (
		<Fragment>
			{stickyBannerData
				? (
					<StickyBanner
						bannerData={stickyBannerData}
						setStickyBannerData={setStickyBannerData}
					/>
				)
				: null
			}

			<PageContainer>
				{
					showBreadcrumb
						? <Breadcrumbs links={breadcrumbLinks} title={breadcrumbTitle}>
							{actionButton}

							{breadcrumbDropdownBtn.map((row, index) => (
								<ButtonDropDown
									key={index}
									label={row.label}
									options={row.options}
									disabled={row.disabled}
									className={row.className}
								/>
							))}

							{breadcrumbButtons.map((row, index) => (
								<Button
									key={index}
									label={row.label}
									className={row.className}
									isLink={row.isLink}
									onClick={row.onClick}
									isRouterLink={row.isRouterLink}
									linkTo={row.linkTo}
									isSubmitButton={row.isSubmitButton}
									openInNewTab={row.openInNewTab}
								>
									{row.children}
								</Button>
							))}
						</Breadcrumbs>
						: null
				}
			</PageContainer>

			<BreadcrumbsContext.Provider value={{
				setBreadcrumbLinks,
				breadcrumbTitle,
				setShowBreadcrumb,
				setBreadcrumbDropdownBtn,
				setBreadcrumbTitle,
				setBreadcrumbButtons,
				setActionButton,
				setStickyBannerData,
				stickyBannerData
			}}>
				{props.children}
			</BreadcrumbsContext.Provider>
		</Fragment>
	);
};

BreadcrumbsContextComponent.propTypes = {
	children: PropTypes.object
};

export default BreadcrumbsContextComponent;
